import React, { useEffect } from "react";

import { useForm } from "react-hook-form";

import styled from "@emotion/styled";

import ReactHookInput from "../../../shared/forms/ReactHookInput";

const Wrapper = styled.div`
    width: 100%;
    ${({ theme }) => theme.breakpoints.from.medium.css`
           width: 80%;
        margin-bottom: 16px;
    `}
`;

interface Inputs {
    search: string;
}

interface iSearch {
    onSearch: (search: string) => void;
    searchTerm: string;
}
const Search = ({ onSearch, searchTerm }: iSearch) => {
    const { control, watch, resetField, setValue } = useForm<Inputs>({
        defaultValues: {
            search: "",
        },
        mode: "onSubmit",
    });

    const watchSearch = watch("search");

    const search = () => {
        onSearch(watchSearch);
    };
    useEffect(() => {
        if (watchSearch !== searchTerm) {
            setValue("search", searchTerm);
        }
    }, [searchTerm]);
    const handleReset = () => {
        resetField("search");
        onSearch("");
    };

    return (
        <Wrapper>
            <ReactHookInput
                placeholder="Suche / Filter"
                name="search"
                resetField={watchSearch.length > 0 && handleReset}
                rules={{}}
                control={control}
                handleClick={search}
            />
        </Wrapper>
    );
};

export default Search;
